import { render } from "./ServicesContainer.vue?vue&type=template&id=07bb2c3a"
import script from "./ServicesContainer.vue?vue&type=script&lang=js"
export * from "./ServicesContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__